var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProgramaUniversidadLayout',{attrs:{"tipo":_vm.tipo}})
}
var staticRenderFns = []

export { render, staticRenderFns }